import { ExpressionDisplayStyle, } from "../../../../../types/forms";
import { isNumericValue } from "../../../../../utils/helpers";
export var EXPRESSION_LOCALE = "pt-BR";
export var EXPRESSION_DEFAULT_CURRENCY = "BRL";
export var EXPRESSION_UNSET_FRACTION_DIGITS = -1;
var FORMAT_PLACEHOLDER_PATTERN = /{(\d+)}/g;
var ISO_DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
var createExpressionDate = function (value) {
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }
    if (typeof value !== "string" && typeof value !== "number") {
        return null;
    }
    var normalized = typeof value === "string" && ISO_DATE_ONLY_PATTERN.test(value.trim())
        ? "".concat(value.trim(), "T00:00:00")
        : value;
    var date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
};
export var getExpressionValueAsStr = function (value, element) {
    var _a, _b, _c, _d;
    var displayStyle = (_a = element.displayStyle) !== null && _a !== void 0 ? _a : ExpressionDisplayStyle.NONE;
    if (displayStyle === ExpressionDisplayStyle.DATE) {
        var date = createExpressionDate(value);
        if (date) {
            return date.toLocaleDateString(EXPRESSION_LOCALE);
        }
    }
    if (displayStyle !== ExpressionDisplayStyle.NONE && isNumericValue(value)) {
        var maximumFractionDigits = (_b = element.maximumFractionDigits) !== null && _b !== void 0 ? _b : EXPRESSION_UNSET_FRACTION_DIGITS;
        var minimumFractionDigits = (_c = element.minimumFractionDigits) !== null && _c !== void 0 ? _c : EXPRESSION_UNSET_FRACTION_DIGITS;
        var options = {
            style: displayStyle,
            currency: element.currency || EXPRESSION_DEFAULT_CURRENCY,
            useGrouping: (_d = element.useGrouping) !== null && _d !== void 0 ? _d : true,
        };
        if (maximumFractionDigits > EXPRESSION_UNSET_FRACTION_DIGITS) {
            options.maximumFractionDigits = maximumFractionDigits;
        }
        if (minimumFractionDigits > EXPRESSION_UNSET_FRACTION_DIGITS) {
            options.minimumFractionDigits = minimumFractionDigits;
        }
        try {
            return Number(value).toLocaleString(EXPRESSION_LOCALE, options);
        }
        catch (_e) {
            return String(value);
        }
    }
    return String(value);
};
export var applyExpressionFormat = function (formattedValue, format) {
    if (!format) {
        return formattedValue;
    }
    return format.replace(FORMAT_PLACEHOLDER_PATTERN, function (match, index) {
        return index === "0" ? formattedValue : match;
    });
};
